export const getRandomStatusCode = (status) => {
  const statusCodes = [200, 42, 409, 43, 45, 423, 422];

  return new Promise((resolve) => {
    setTimeout(() => {
      const randomIndex = Math.floor(Math.random() * statusCodes.length);
      resolve(status || statusCodes[randomIndex]);
    }, 3000); // 3000 milliseconds delay
  });
};

export const getControllersData = (controllers) => {
  const data = [];

  for (const key in controllers) {
    data.push({
      id: `${Date.now()}_${key}`,
      name: key,
      img: "https://invidtech.com/cdn/shop/files/INVID-AIR-CR_3000_700x700.jpg?v=1695215162",
    });
  }
  return data;
};

export const replaceVirtualController = (text) => {
  const targetPhrase = "VIRTUAL CONTROLLER";

  const words = text.split(" ");

  if (words.slice(-2).join(" ") === targetPhrase) {
    const partBefore = words.slice(0, -2).join(" ");

    return `${partBefore} Virtual`;
  }
  return text;
};

export const createAPList = (data) => {
  const result = [];
  for (const key in data) {
    const item = data[key];
    result.push({
      id: key,
      type: key,
      name: key.toUpperCase(),
      img: `${process.env.VUE_APP_BACK}/${item.img}` || "https://developp.exportfeed.com/wp-content/uploads/2023/09/64508202-test-written-by-hand-hand-writing-on-transparent-board-photo.jpg",
      // img: item.image_url,
    });
  }

  return result || []
}

function cleanString(input) {
  if (typeof input !== "string") {
    throw new Error("Input must be a string");
  }
  // Remove the first and last double quotes if they exist
  let trimmed = input;
  if (input.startsWith('"') && input.endsWith('"')) {
    trimmed = input.slice(1, -1);
  }
  // Remove all backslashes
  return trimmed.replace(/\\/g, "");
}
export const createTemplateList = (data) => {
  const result = {};
  for (const element of data) {
    let parsedData = element.data ? JSON.parse(element.data) : {}
    let KEY = element.access_point_type.startsWith("turnstile") ? "turnstile" : element.access_point_type

    if (result[KEY]) {
      if (element.default_template) {
        result[KEY].checkBox.push({ label: element.name, value: element.id, data: parsedData })
      } else {
        result[KEY].options.push({ label: element.name, value: element.id, data: parsedData })
      }
    } else {
      result[KEY] = { checkBox: [], options: [] }
      if (element.default_template) {
        result[KEY].checkBox.push({ label: element.name, value: element.id, data: parsedData })
      } else {
        result[KEY].options.push({ label: element.name, value: element.id, data: parsedData })
      }
    }
  }
  return result
}

export const createComponentSourceData = (ext_devices, expansion_boards) => {
  let inputsPortCount = 0;
  let outputsPortCount = 0;
  const inputs = [{ id: 0, label: "ACU", value: 0, disabled: false }];
  const outputs = [{ id: 0, label: "ACU", value: 0, disabled: false }];
  const readers = [{ id: 0, label: "ACU", value: 0, disabled: false }];
  for (const element of ext_devices) {

    if (expansion_boards.alarm_board[element.ext_board]) {
      if (expansion_boards.alarm_board[element.ext_board]?.inputs) {
        inputs.push({ id: element.ext_board, ...element, label: element.name, value: element.ext_board, disabled: false });
        inputsPortCount = expansion_boards.alarm_board[element.ext_board].inputs;
      } else {
        outputs.push({ id: element.ext_board, ...element, label: element.name, value: element.ext_board, disabled: false });
        outputsPortCount = expansion_boards.relay_board[element.ext_board].outputs;
      }
    } else if (expansion_boards.reader_board[element.ext_board]) {
      readers.push({ id: element.ext_board, ...element, label: element.name, value: element.ext_board, disabled: false })
    } else {
      if (!!expansion_boards.relay_board[element.ext_board]) {
        if (expansion_boards.relay_board[element.ext_board]?.inputs) {
          inputs.push({ id: element.ext_board, ...element, label: element.name, value: element.ext_board, disabled: false });
          inputsPortCount = expansion_boards.relay_board[element.ext_board].inputs;
        } else {
          outputs.push({ id: element.ext_board, ...element, label: element.name, value: element.ext_board, disabled: false });
          outputsPortCount = expansion_boards.relay_board[element.ext_board].outputs;
        }
      }
    }
  }
  return {
    inputsData: {
      inputs,
      inputsPortCount
    },
    outputsData: {
      outputs,
      outputsPortCount,
    },
    readersData: {
      readers
    }
  }
}


export const getFirstAvailableNumber = (selectedNumbers) => {
  const allNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const selectedSet = new Set(selectedNumbers.map(Number));

  for (const num of allNumbers) {
    if (!selectedSet.has(Number(num))) {
      return num;
    }
  }
  return 1;
};